import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Form } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import TableForm from "../TableForm";
import ConfirmModal from "../ConfirmModal";

const JobTypeForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const defaultData = {
    Job_Type_Code: "",
    Job_Type_Name: "",
    Job_Type_Des: "",
    Com_Code: user.Com_Code
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const inputField = [
    {
      name: "Job_Type_Code",
      label: "รหัสประเภทงาน",
      pattern: /^(?!.*[^\w]).{1,20}$/.source,
      feedbackMessage:
        "ข้อมูลไม่ถูกต้อง โปรดใช้เฉพาะตัวอักษรตัวพิมพ์ใหญ่หรือตัวเลข และห้ามเป็นค่าว่างหรือเว้นวรรค (สูงสุด 20 ตัวอักษร)",
      readOnly: !!editData,
      type: "text"
    },
    { name: "Job_Type_Name", label: "ชื่อประเภทงาน", type: "text" },
    { name: "Job_Type_Des", label: "รายละเอียด", type: "text" }
  ];

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Array[0]);
    }
  };

  useEffect(() => {
    if (editData) {
      setData({
        Array: [
          {
            Job_Type_Code: editData.Job_Type_Code,
            Job_Type_Name: editData.Job_Type_Name,
            Job_Type_Des: editData.Job_Type_Des,
            Com_Code: editData.Com_Code
          }
        ]
      });
    }
  }, [editData]);

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <Card.Body>
          <TableForm
            data={data.Array}
            columns={inputField}
            editForm={!!editData}
            defaultData={defaultData}
            onChangeCallback={(newData) => setData({ Array: newData })}
          />
        </Card.Body>

        <Card.Footer className="p-3 text-end border-top-0 bg-transparent">
          <Button
            type="submit"
            variant="success"
            className="me-2 px-5 py-2 text-dark rounded-pill"
          >
            {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
          </Button>
          <ConfirmModal
            show={showModal}
            data={data}
            content={editData ? "edit" : "save"}
            onSubmitCallback={handleSubmit}
          />

          <Button
            variant="outline-success"
            className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
            onClick={() =>
              navigate("/wo_master/job_type", { state: "JobType" })
            }
          >
            ยกเลิก
          </Button>
        </Card.Footer>
      </Form>
    </>
  );
};

JobTypeForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default JobTypeForm;
